import { api } from "roboflex-thalamus-request-handler";

/**
 * Lista todos os programas.
 * @returns {Promise<Array>}
 */
export async function listarProgramas() {
  const { data } = await api.get("programa/listar", {});
  return data;
}

/**
 * Busca um programa por ID (detalhes e associações).
 * @param {number} id
 * @returns {Promise<Object>}
 */
export async function buscarPrograma(id) {
  const { data } = await api.get(`programa/buscar/${id}`);
  return data;
}

/**
 * Cadastra novo programa.
 * @param {Object} payload - { nome, dtInicio, dtFim, gerente_id, setor_id }
 * @returns {Promise<Object>}
 */
export async function cadastrarPrograma(payload) {
  const { data } = await api.post("programa/cadastrar", {
    ...payload,
    status: payload.status ?? "Proposto",
  });
  return data;
}

/**
 * Atualiza um programa (campos parciais).
 * @param {number} id
 * @param {Object} payload - campos a atualizar
 */
export async function atualizarPrograma(id, payload) {
  await api.put(`programa/atualizar/${id}`, payload);
}

/**
 * Marca programa como excluído.
 * @param {number} id
 * @param {number} usuarioId
 */
export async function excluirPrograma(id, usuarioId) {
  await api.put(`programa/excluir/${id}`, { usuario_id: usuarioId });
}

/**
 * Associa projeto ou plano de ação ao programa.
 * @param {number} programaId
 * @param {number} id - ID do projeto ou plano
 * @param {boolean} ehProjeto - true = projeto, false = plano de ação
 * @returns {Promise<Object>} - response.data com associacao_id
 */
export async function associarAoPrograma(programaId, id, ehProjeto) {
  const { data } = await api.post(`programa/associar/${programaId}`, {
    id,
    projeto: ehProjeto ? 1 : 0,
  });
  return data;
}

/**
 * Remove associação de projeto/plano do programa.
 * @param {number} programaId
 * @param {number} id - associacao_id ou id do item
 * @param {boolean} ehProjeto
 */
export async function desassociarDoPrograma(programaId, id, ehProjeto) {
  await api.post(`programa/associar/excluir/${programaId}`, {
    id,
    projeto: ehProjeto ? 1 : 0,
  });
}

/**
 * Lista projetos e planos de ação que ainda não têm programa.
 * @returns {Promise<{ projeto: Array, planoAcao: Array }>}
 */
export async function listarProjetosPlanoSemPrograma() {
  const { data } = await api.get("planoacao-projeto/listar/sem-programa");
  return data;
}
